<template>
	<div class="row-fluid fondo-pie-pagina text-white px-3 px-lg-4">
		<div class="col-12">
			<div class="row fuente-etiquetas pt-4">
				<div class="col-12 col-md-8 col-lg-8">
					<div class="row">
						<div class="col-6 col-sm-5 col-md-4">
							<ul>
								<li>
									<router-link class="link" to="/nosotros#top">Nosotros</router-link>
								</li>
							</ul>
						</div>
						<div class="col-6 col-sm-5 col-md-4">
							<ul>
								<li>
									<router-link class="link" to="/preguntas-frecuentes#top">Preguntas frecuentes</router-link>
								</li>
							</ul>
						</div>
						<div class="d-none d-xl-block col-xl-4">
							<span>&nbsp;</span>
						</div>
						<div class="col-6 col-sm-5 col-md-4 d-block d-sm-none d-md-block">
							<ul>
								<li>
									<router-link class="link" to="/quiero-ser-cliente#top">Quiero ser cliente</router-link>
								</li>
							</ul>
						</div>
						<div class="col-6 col-sm-5 col-md-4">
							<ul>
								<li>
									<router-link class="link" to="/contacto#top">Contacto</router-link>
								</li>
							</ul>
						</div>
						<div class="col-6 col-sm-5 col-md-4 d-none d-sm-block d-md-none">
							<ul>
								<li>
							<router-link class="link" to="/quiero-ser-cliente#top">Quiero ser cliente</router-link>
								</li>
							</ul>
						</div>
						<div class="d-none d-xl-block col-xl-4">
							<span>&nbsp;</span>
						</div>
						<div class="col-6 col-sm-5 col-md-4">
							<ul>
								<li>
									<router-link class="link" to="/bolsa-trabajo#top">Bolsa de trabajo</router-link>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-4">
					<div class="row">
						<div class="col-12 pt-3 pt-md-0">
							<p class="p-0 m-0">Contacto:</p>
							<p class="p-0 m-0">(667) 715 19 00</p>
							<p class="p-0 m-0">contacto@difarmer.com</p>
							<p class="py-1">
								<a href="https://bit.ly/39Lfp0n">
									<img src="@/assets/img-pub/whatsapp.png" /> 
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row fuente-etiquetas text-center pt-4 pb-4">
				<div class="col-12">
					<span>
						&#169; 1960-{{year}} Difarmer S.A. de C.V.
						<router-link
							class="link d-inline aviso-privacidad"
							to="/aviso-privacidad/#top"
						>Aviso de privacidad</router-link>.
					</span>
				</div>
			</div>
			<!-- <div class="d-flex justify-content-end">
				<span class="">Version: {{versionWeb}}</span>
			</div> -->
		</div>
		<bolsa-trabajo-boton-flotante/>
	</div>
</template>

<script>
import BolsaTrabajoBotonFlotante from "@/components/publica/BolsaTrabajoBotonFlotante"
	/* import {version} from '../../../package' */

	export default {
		/* data() {
			return {
				versionWeb: version,
			}
		}, */
		methods: {
			// scroll() {
			// 	location.hash = "nosotros#header-ancla"
			// }
		},
		computed: {
			year() {
				return new Date().getFullYear()
			}
		},
		components:{
			BolsaTrabajoBotonFlotante			
		}
	}
</script>

<style scoped>
	.fondo-pie-pagina {
		background-color: #000716;
	}
	.fuente-etiquetas {
		font-family: "Open Sans", sans-serif;
	}
	.aviso-privacidad {
		text-decoration: underline;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-etiquetas {
			font-size: 12px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-etiquetas {
			font-size: 13px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-etiquetas {
			font-size: 13px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-etiquetas {
			font-size: 15px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-etiquetas {
			font-size: 16px !important;
		}
	}
</style>